<template>
  <div class="greater-than">
    <p class="page-title">Apply Your Knowledge</p>
    <h1 class="question">Which materials have a specific heat capacity greater than or equal to 1.8 J/g°C?</h1>

    <div class="answers">

      <div class="answer" v-for="material of getMaterials" :key="material.id" 
      @click="checkAll === false ? togglePick(material.id) : ''"
      :style="{pointerEvents: checkAll === true ? 'none' : 'auto' }"
      :class="{
      'picked': picked.includes(material.id),
      'correct': checkAll === true && (material.heatCapacity >= 1.8 && picked.includes(material.id)),
      'fade-correct': checkAll === true && (material.heatCapacity >= 1.8),
      'wrong':  checkAll === true && (material.heatCapacity < 1.8 && picked.includes(material.id)),
      'fade-wrong':  checkAll === true && (material.heatCapacity < 1.8),
      'fade': checkAll === true && !picked.includes(material.id)}">
        
        <div class="symbol-contain" v-if="checkAll">
          <div class="symbol-color">
            <span class="symbol" v-if="material.heatCapacity >= 1.8 && picked.includes(material.id) || material.heatCapacity < 1.8 && !picked.includes(material.id)">
              &check;
            </span>
            <span class="symbol" v-if="material.heatCapacity < 1.8 && picked.includes(material.id) || material.heatCapacity >= 1.8 && !picked.includes(material.id)">
              &times;
            </span>
            <p class="heat-capacity-answer">{{ material.heatCapacity }} J/g&deg;C</p>
          </div>
        </div>

        <div class="box">
          <p class="text">{{material.text}}</p>
          <div class="dot-contain">
            <Dots :offset="true" :fill="material.fill" :wiggle="material.wiggle" :w="180" :h="180" :r="40" />
          </div>
        </div>
      </div>
    </div>

    <button class="btn" :disabled="picked.length < 1" @click="checkAll = true" v-if="!checkAll">Continue &RightArrow;</button>
    <router-link to="/quiz/cost" class="btn" v-if="checkAll">Continue &RightArrow;</router-link>

  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import Dots from '../components/Dots'
export default {
  components:{
    Dots
  },
  data() {
    return {
      picked: [],
      checkAll: false
    }
  },
  computed: mapGetters(['getMaterials']),
  methods: {
    togglePick(id){
      if(this.picked.includes(id)){
        this.picked = this.picked.filter(item => item !== id);
      }else{
        this.picked.push(id)
      }
    }
  },
}
</script>


<style lang="scss">
  .greater-than{
    max-width: 69rem;
    margin: 0 auto;
    padding: 3rem;

    .top-row{
      text-align-last: left;
      margin: 2rem 0;
      width: 100%;
      text-transform: uppercase;
      font-weight: bold;
      flex: 0 0 auto;
      color: $grey;
    }

    .question{
      font-size: 2rem;
      font-weight: bold;
      margin-top: 2rem;
    }

    .answers{
      display: flex;
      width: 100%;
      // grid-template-columns: repeat(4, 15rem);
      margin: 3rem 0;

      .answer{
        margin: 0 1rem;
        flex: 1 1 15rem;
        border: solid 2px transparent;
        position: relative;

        .symbol-contain{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          z-index: 10;
          padding-bottom: 1rem;

          .symbol-color{
            width: 80%;
            border-radius: 0.5rem;
            background: rgba($light, 1);
            font-weight: bold;
            text-shadow: 1px 1px 0 darken($light, 10%);
            display: flex;
            justify-content: center;
            align-items: center;

            .symbol{
              display: none;
              font-size: 1.5rem;
              padding: 0.5rem 1rem;
            }

            .heat-capacity-answer{
              padding: 1rem 0.3rem;
              margin: 0;
              font-size: 0.9rem;
            }

            @supports(backdrop-filter: blur(5px)){
              backdrop-filter: blur(5px);
              background: rgba($light, 0.8);
            }
            

            p{
              margin: 0;
              margin-bottom: 1rem;
              font-size: 1.5rem;
            }

          }

        }

        .box{
          box-shadow: 2px 2px 5px rgba($dark, 0.5);
          cursor: pointer;
          width: 100%;
          display: block;
          padding-bottom: 1rem;
        }
        
        .dot-contain{
          overflow: hidden;
          max-height: 12rem;

        }

        .text{
          background: $light;
          margin: 0;
          padding: 1rem;
          margin-bottom: 1rem;
          transition: all 250ms;
        }

        &:hover{
          .text{
            background: $blue;
            color: #ffffff;
          }
        }

        &.picked{
          .text{
            background: $green;
            color: #ffffff;
          }
        }

        &.fade{
          .box{
            opacity: 0.5;
          }
        }

        &.fade-correct{
          border-color: $green;
        }

        &.fade-wrong{
          border-color: $red;
        }

        &.correct{
          // border-color: $green;

          

          .symbol-color{
            background: rgba($green, 1);
            color: #ffffff;
            font-weight: bold;
            text-shadow: 1px 1px 0 darken($green, 10%);

            .symbol{
            display: block;
          }

            @supports(backdrop-filter: blur(5px)){
              backdrop-filter: blur(5px);
              background: rgba($green, 0.8);
            }
          }
        }

        &.wrong{
          // border-color: $red;

          .symbol-color{
            background: rgba($red, 1);
            color: #ffffff;
            font-weight: bold;
            text-shadow: 1px 1px 0 darken($red, 10%);

            .symbol{
              display: block;
            }

            @supports(backdrop-filter: blur(5px)){
              backdrop-filter: blur(5px);
              background: rgba($red, 0.8);
            }
          }
        }
      }
    }
  }
</style>